import { useQuery } from "@tanstack/vue-query";
import Billing from "@/services/billing/billing";

export function useInvoices() {
  return useQuery({
    queryKey: ["billing", "invoices"] as const,
    queryFn: async () => {
      const result = await Billing.getInvoices();
      const payload = result?.data as { status?: boolean; data?: unknown };
      if (payload?.status && payload?.data != null) return payload.data;
      return [];
    },
    staleTime: 0,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
}
